module.exports = __webpack_public_path__ + "img/saturn.2becb7da.svg";